import { Component, OnInit,ViewChild,ElementRef} from '@angular/core';
import { APIService } from '../../../../app/api.service';
import { CommonService } from '../../../services/common.service';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-print-profit-loss',
  templateUrl: './print-profit-loss.component.html',
  styleUrls: ['./print-profit-loss.component.scss']
})

export class PrintProfitLossComponent implements OnInit {

  jarvisData: any = [];
  selectedFY: any;
  financialYears: any = []; 
  LedgerRecord: any = [];
  HeadRecord: any = [];
  AccurateProfitOrLoss: any = [];
  profitAndLossParameters: any = [];
  ProfitOrLoss: number = 0;
  GrandIncome: number = 0;
  GrandExpense: number = 0;
  IncomeArray: any = [];
  ExpenseArray: any = [];
  BindRecordLeft: any = [];
  BindRecordRight: any = [];
  profitLoss: any = [];
  hideZeroLevelLdgr: boolean = false;
  fromDate: any;
  toDate: any;
  selectedDate: any;
  acctStartDT: Date = new Date("2020");
  isShowExpense: boolean = true;
  isShowIncome: boolean = false;
  agencyData:any = [];
  AgencyName:string = '';
  printDiv: string = '';

  constructor(private apiService: APIService,private commonService: CommonService, private titleSer: Title, private SpinnerService: NgxSpinnerService) { }
  //@ViewChild('profitloss') profitloss: ElementRef;
  
  ngOnInit(): void {
    //console.log(this.profitloss.nativeElement.innerHTML);
    let jarvis = this.apiService.getCookie("Jarvis");
          if (jarvis) {
              this.jarvisData = JSON.parse(jarvis);
        };  
        let agencyData = this.apiService.getCookie("M");
        if (agencyData) {
          this.agencyData = JSON.parse(agencyData);
        }

        this.financialYears = this.checkFinancialYear(this.acctStartDT, new Date());
        this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;       
        let currentDate = new Date();
        this.fn_Set_FinancialYear(currentDate);
        this.getProfitAndLoss();
        setTimeout(() => {
          this.titleSer.setTitle("Profit and Loss - Biziverse");
        }, 200);
  }

  

  
  //checkFinancialYear() - 
  checkFinancialYear(date1: any, date2: any) {
    let financialYear = [];
    let fYear = new Date(date1).getFullYear();
    let lYear = new Date(date2).getFullYear();
    let toValueCheck = lYear;
    if (fYear == lYear) {
        let fMonth = new Date(date1).getMonth() + 1;
        if (fMonth < 4) {
            fYear = fYear - 1;
        }
        else {
            fYear = fYear;
        }
        let lMnth = new Date(date2).getMonth() + 1;
        if (lMnth > 3) {
            toValueCheck = lYear + 1;
        }
        
    }
    else {
        let fMonth = new Date(date1).getMonth() + 1;
        if (fMonth < 4) {
            fYear = fYear - 1;
        }
        else {
            fYear = fYear;
        }

        let lMnth = new Date(date2).getMonth() + 1;
        if (lMnth > 3) {
            toValueCheck = lYear + 1;
        }
    }


    for (var i = fYear; i < toValueCheck; i++) {
        financialYear.push({ 'FY': this.getCurrentFinancialYear('1-Apr-' + i) })
    }
    return financialYear;
  }

    //getCurrentFinancialYear()
    getCurrentFinancialYear(fromDT: any) {
      var fiscalyear = "";
      var today = new Date(fromDT);
      if ((today.getMonth() + 1) < 4) {
          fiscalyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
      } else {
          fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
      }
      return fiscalyear
    }

    fn_Set_FinancialYear(ToDT: any) {
      var Date1 = new Date(ToDT);
      var Year;
      var IsPrevios = 0;
      if (Date1.getMonth() < 3) {
          Year = Date1.getFullYear() - 1
          IsPrevios = 1;
      } else {
          Year = Date1.getFullYear() + 1
          IsPrevios = 0;
      }
      if (IsPrevios == 1) {
          this.fromDate = new Date(Year + "/04/01");
          this.toDate = new Date(Date1.getFullYear() + "/03/31");
      }
      else if (IsPrevios == 0) {
          this.fromDate = new Date(Date1.getFullYear() + "/04/01");
          this.toDate = new Date(Year + "/03/31");
      }
  
      this.LedgerRecord = [];
      this.HeadRecord = [];
      this.AccurateProfitOrLoss = [];
      this.profitAndLossParameters = [];
      this.BindRecordLeft = [];
      this.BindRecordRight = [];
  
      //this.getProfitAndLoss();
  }

  
  getProfitAndLoss(){
    this.fromDate = this.commonService.GetParam('FDT');
    this.toDate = this.commonService.GetParam('TDT');
    this.AgencyName = this.agencyData[0].AgencyName;
    let data = [{
      fromDT: this.fromDate,
      toDT: this.toDate
    }]

    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'get',
        moduleID: 1,
        data: JSON.stringify(data)
    }];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));  
  }
  
  //failureResp - failure handler
  failureResp(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    }
    else {
        alert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    }
    else {
        if (res) {
          var reponseData = JSON.parse(res.updatePackage);
          this.LedgerRecord = reponseData.Table1;
          this.HeadRecord = reponseData.Table2;
          this.AccurateProfitOrLoss = reponseData.Table3;
          //this.profitAndLossParameters = reponseData.Table4;
          this.fn_BindBalanceSheetData()
         this.printProfitLossData()
          
        }
    }
  }

  //fn_BindBalanceSheetData() - Bind Data to balance sheet
  fn_BindBalanceSheetData(){
    
    this.ProfitOrLoss = 0;
    this.GrandIncome = 0;
    this.GrandExpense = 0;
    this.IncomeArray = [];
    this.ExpenseArray = [];
    let headID: number = 0;
    //this.resetBalanceSheet();

    //Left side data bind
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if(this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 4){
        headID = this.HeadRecord[i].HeadID;
        this.BindRecordLeft.push({
          HeadID: this.HeadRecord[i].HeadID,
          HeadName: this.HeadRecord[i].HeadName,
          OpBal: this.HeadRecord[i].OpBal,
          CloBal: this.HeadRecord[i].CloBal,
          LedgerID: 0,
          SubHead: $.grep(this.HeadRecord, function (e: any) { return e.ParentHeadID == headID && e.LedgerType == 4 }),
          Ledger: $.grep(this.LedgerRecord, function (e: any) { return e.HeadID == headID})
        });
      };             
    }

    //Right side data bind
    headID = 0;
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if(this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 3){
        headID = this.HeadRecord[i].HeadID;
        this.BindRecordRight.push({
          HeadID: this.HeadRecord[i].HeadID,
          HeadName: this.HeadRecord[i].HeadName,
          OpBal: this.HeadRecord[i].OpBal,
          CloBal: this.HeadRecord[i].CloBal,
          LedgerID: 0,
          SubHead: $.grep(this.HeadRecord, function (e: any) { return e.ParentHeadID == headID && e.LedgerType == 3 }),
          Ledger: $.grep(this.LedgerRecord, function (e: any) { return e.HeadID == headID })
        });
      };               
    }

    this.GrandIncome = this.fn_calculateGrandTotal(this.BindRecordRight, this.AccurateProfitOrLoss);
    this.GrandExpense = this.fn_calculateExpenseTotal(this.BindRecordLeft, this.AccurateProfitOrLoss);
    this.ProfitOrLoss = Number(this.GrandIncome) - Number(this.GrandExpense);
    if (Number(this.ProfitOrLoss) > 0) {
      this.GrandExpense += Number(String(this.ProfitOrLoss).replace(/\-/g, ""));
    }
    else {
      this.GrandIncome += Number(String(this.ProfitOrLoss).replace(/\-/g, ""));
    }
  }

  fn_calculateGrandTotal(arr1: any, arr2: any) {
    var total = 0;
    if (!arr1) {
      arr1 = [];
    }

    if (!arr2) {
      arr2 = [];
    }

    for (var i = 0; i < arr1.length; i++) {
      total += parseFloat(String(arr1[i].CloBal).replace(/\,/g, "").replace(/\-/g, ""));
    }
    for (var i = 0; i < arr2.length; i++) {
      total += parseFloat(String(arr2[i].ClosingStock).replace(/\,/g, "").replace(/\-/g, ""));
    }
    return total;
  }

  fn_calculateExpenseTotal(arr1: any, arr2: any) {
    var total = 0;
    if (!arr1) {
      arr1 = [];
    }

    if (!arr2) {
      arr2 = [];
    }

    for (var i = 0; i < arr1.length; i++) {
      total += parseFloat(String(arr1[i].CloBal).replace(/\,/g, "").replace(/\-/g, ""));
    }
    for (var i = 0; i < arr2.length; i++) {
      total += parseFloat(String(arr2[i].OpeningStock).replace(/\,/g, "").replace(/\-/g, ""));
    }
    return total;

  }

printProfitLossData(){
  setTimeout(function () {
    var printArea = $('#profitloss').html();
    $('body').html(printArea); 
    window.print(); 
});
        // var printArea = $('#profitloss').html();
        // $('body').html(printArea);
        // window.print();
  }


}

declare global {
  interface Date {
    customFormat(formatString : any): string;
  }
}


// String Prototye
Date.prototype.customFormat = function(formatString : any) {
  var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
  YY = ((YYYY = this.getFullYear()) + "").slice(-2);
  MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
  MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
  DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
  DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
  th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
  formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
  h = (hhh = this.getHours());
  if (h == 0) h = 24;
  if (h > 12) h -= 12;
  hh = h < 10 ? ('0' + h) : h;
  hhhh = h < 10 ? ('0' + hhh) : hhh;
  AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
  mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
  ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
  return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}

